import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterLink } from '@angular/router';
import { ApiService } from '../../services/api.service';
import { DashboardStats } from '../../models';

@Component({
  selector: 'app-dashboard',
  standalone: true,
  imports: [CommonModule, RouterLink],
  template: `
    <div class="artisan-dashboard page-container">
      
      <!-- MOBILE STREAMLINED DASHBOARD -->
      <div class="mobile-only mobile-home-container">
        <div class="mobile-home-header card">
          <div class="card-swatch-top"></div>
          <h1>Ciao Guido 👋</h1>
          <p>{{ todayDate | date:'EEEE d MMMM':'':'it' }}</p>
        </div>

        <div class="mobile-quick-actions-grid">
          <a routerLink="/preventivi/nuovo" class="m-action-card terracotta-bg">
            <span class="material-icons">post_add</span>
            <span>Nuovo Preventivo</span>
          </a>
          <a routerLink="/appuntamenti" class="m-action-card teal-bg">
            <span class="material-icons">event</span>
            <span>Agenda & Cantieri</span>
          </a>
          <a routerLink="/clienti" class="m-action-card blue-bg">
            <span class="material-icons">people</span>
            <span>Rubrica Clienti</span>
          </a>
          <a routerLink="/preventivi" class="m-action-card amber-bg">
            <span class="material-icons">description</span>
            <span>Preventivi</span>
          </a>
        </div>

        <div class="mobile-status-card card" *ngIf="stats">
          <h3>📊 Riepilogo Rapido</h3>
          <div class="status-row" routerLink="/preventivi">
            <span>Preventivi attivi in attesa</span>
            <strong>{{ stats.preventivoInAttesa }}</strong>
          </div>
          <div class="status-row" routerLink="/appuntamenti">
            <span>Cantieri / Appuntamenti oggi</span>
            <strong>{{ stats.appuntamentiOggi }}</strong>
          </div>
          <div class="status-row" routerLink="/fatture">
            <span>Bozze fatture da emettere</span>
            <strong>{{ stats.fattureDaEmettere }}</strong>
          </div>
        </div>
      </div>

      <!-- DESKTOP ARTISAN WORKBENCH -->
      <div class="desktop-only">
        <!-- Artisan Workbench Header -->
        <div class="workbench-header card">
          <div class="card-swatch-top"></div>
          <div class="workbench-info">
            <div class="badge-artisan">
              <span class="material-icons" style="font-size: 16px;">palette</span>
              <span>Studio di Pittura & Decorazione</span>
            </div>
            <h1>Bentornato, Guido 👋</h1>
            <p class="workbench-subtitle">Il tuo banco di lavoro digitale per preventivi, cantieri e contabilità.</p>
          </div>
          <div class="workbench-date-badge">
            <span class="material-icons">event</span>
            <div>
              <span class="date-day">{{ todayDate | date:'EEEE':'':'it' }}</span>
              <span class="date-num">{{ todayDate | date:'d MMMM yyyy':'':'it' }}</span>
            </div>
          </div>
        </div>

        <!-- Quick Metrics Ribbon -->
        <div class="metrics-ribbon" *ngIf="stats">
          <div class="metric-pill">
            <span class="metric-dot terracotta"></span>
            <div class="metric-data">
              <strong>{{ stats.preventivoInAttesa }}</strong>
              <span>Preventivi Attivi</span>
            </div>
          </div>
          <div class="metric-pill">
            <span class="metric-dot amber"></span>
            <div class="metric-data">
              <strong>{{ stats.fattureDaEmettere }}</strong>
              <span>Bozze Fattura</span>
            </div>
          </div>
          <div class="metric-pill">
            <span class="metric-dot teal"></span>
            <div class="metric-data">
              <strong>{{ stats.appuntamentiOggi }}</strong>
              <span>Cantieri Oggi</span>
            </div>
          </div>
          <div class="metric-pill">
            <span class="metric-dot gold"></span>
            <div class="metric-data">
              <strong>€ {{ stats.importiMese | number:'1.2-2' }}</strong>
              <span>Fatturato Mese</span>
            </div>
          </div>
        </div>

        <!-- Main Action: New Estimate & Quick Tools -->
        <div class="actions-workbench-grid">
          <a routerLink="/preventivi/nuovo" class="action-tile tile-primary">
            <div class="tile-icon-circle">
              <span class="material-icons">post_add</span>
            </div>
            <div class="tile-content">
              <h3>Crea Nuovo Preventivo</h3>
              <p>Compila voci di lavoro e genera PDF professionale in 1 minuto</p>
            </div>
            <span class="material-icons tile-arrow">arrow_forward</span>
          </a>

          <a routerLink="/fatture/nuova" class="action-tile tile-secondary">
            <div class="tile-icon-circle amber">
              <span class="material-icons">receipt</span>
            </div>
            <div class="tile-content">
              <h3>Emetti Nuova Fattura</h3>
              <p>Registra fattura o proforma collegata al cliente</p>
            </div>
            <span class="material-icons tile-arrow">arrow_forward</span>
          </a>
        </div>

        <!-- 4 Core Navigation Cards -->
        <div class="modules-grid">

          <a routerLink="/preventivi" class="module-card card-terracotta">
            <div class="module-top">
              <div class="module-icon">
                <span class="material-icons">description</span>
              </div>
              <span class="module-badge">Preventivi</span>
            </div>
            <div class="module-body">
              <h2>Gestione Preventivi</h2>
              <p>Monitora lo stato di accettazione, invia PDF via email e converti in fattura con un click.</p>
            </div>
            <div class="module-footer">
              <span>Apri archivio</span>
              <span class="material-icons">chevron_right</span>
            </div>
          </a>

          <a routerLink="/fatture" class="module-card card-amber">
            <div class="module-top">
              <div class="module-icon">
                <span class="material-icons">receipt_long</span>
              </div>
              <span class="module-badge">Contabilità</span>
            </div>
            <div class="module-body">
              <h2>Fatture & Proforma</h2>
              <p>Tieni traccia delle fatture emesse, pagate e dei corrispettivi fiscali.</p>
            </div>
            <div class="module-footer">
              <span>Apri archivio</span>
              <span class="material-icons">chevron_right</span>
            </div>
          </a>

          <a routerLink="/appuntamenti" class="module-card card-teal">
            <div class="module-top">
              <div class="module-icon">
                <span class="material-icons">calendar_month</span>
              </div>
              <span class="module-badge">Agenda</span>
            </div>
            <div class="module-body">
              <h2>Sopralluoghi & Cantieri</h2>
              <p>Calendario mensile interattivo per organizzare sopralluoghi e giornate di tinteggiatura.</p>
            </div>
            <div class="module-footer">
              <span>Apri agenda</span>
              <span class="material-icons">chevron_right</span>
            </div>
          </a>

          <a routerLink="/clienti" class="module-card card-blue">
            <div class="module-top">
              <div class="module-icon">
                <span class="material-icons">people</span>
              </div>
              <span class="module-badge">Anagrafica</span>
            </div>
            <div class="module-body">
              <h2>Rubrica Clienti</h2>
              <p>Contatti telefonici, indirizzi di cantiere e storico lavori per ogni cliente.</p>
            </div>
            <div class="module-footer">
              <span>Apri rubrica</span>
              <span class="material-icons">chevron_right</span>
            </div>
          </a>

        </div>

        <!-- Artisan Tip Banner -->
        <div class="artisan-tip-card card">
          <div class="tip-icon">💡</div>
          <div class="tip-text">
            <strong>Consiglio di bottega:</strong> Ricordati di impostare la tua Partita IVA e l'IBAN nella sezione <a routerLink="/impostazioni">Impostazioni</a> così compariranno automaticamente nei PDF di fatture e preventivi.
          </div>
        </div>
      </div>

    </div>
  `,
  styles: [`
    .page-container {
      max-width: 1200px;
      margin: 0 auto;
      padding-bottom: 40px;
    }

    .mobile-only { display: none !important; }
    .desktop-only { display: block !important; }

    /* Mobile Streamlined Dashboard */
    .mobile-home-container {
      display: flex;
      flex-direction: column;
      gap: 32px;
    }
    .mobile-home-header {
      padding: 24px 20px;
      text-align: center;
    }
    .mobile-home-header h1 {
      margin: 0 0 6px 0;
      font-size: 24px;
      font-weight: 800;
      color: var(--text-main);
    }
    .mobile-home-header p {
      margin: 0;
      font-size: 13px;
      color: var(--text-muted);
      text-transform: capitalize;
    }

    .mobile-quick-actions-grid {
      display: grid;
      grid-template-columns: repeat(2, 1fr);
      gap: 16px;
    }
    .m-action-card {
      background: var(--surface);
      border: 1px solid var(--border);
      border-radius: 18px;
      padding: 24px 16px;
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 12px;
      text-decoration: none;
      color: var(--text-main);
      box-shadow: var(--shadow);
      text-align: center;
      font-weight: 700;
      font-size: 13px;
      transition: transform 0.15s;
    }
    .m-action-card:active { transform: scale(0.97); }
    .m-action-card .material-icons {
      font-size: 32px;
      padding: 14px;
      border-radius: 14px;
    }
    .terracotta-bg .material-icons { background: rgba(200, 90, 50, 0.15); color: var(--primary); }
    .teal-bg .material-icons { background: rgba(13, 148, 136, 0.15); color: var(--success); }
    .blue-bg .material-icons { background: rgba(37, 99, 235, 0.15); color: #2563eb; }
    .amber-bg .material-icons { background: rgba(217, 119, 6, 0.15); color: var(--accent); }

    .mobile-status-card {
      padding: 24px 20px;
    }
    .mobile-status-card h3 {
      margin: 0 0 14px 0;
      font-size: 16px;
      font-weight: 700;
      color: var(--text-main);
    }
    .status-row {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 14px 0;
      border-bottom: 1px solid var(--border);
      font-size: 13px;
      color: var(--text-muted);
      text-decoration: none;
    }
    .status-row:last-child { border-bottom: none; }
    .status-row strong {
      color: var(--text-main);
      font-size: 16px;
    }

    /* Workbench Header */
    .workbench-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 36px;
      margin-bottom: 24px;
      flex-wrap: wrap;
      gap: 20px;
    }

    .badge-artisan {
      display: inline-flex;
      align-items: center;
      gap: 8px;
      background: var(--primary-light);
      color: var(--primary);
      padding: 6px 14px;
      border-radius: 20px;
      font-size: 12px;
      font-weight: 700;
      letter-spacing: 0.3px;
      margin-bottom: 12px;
    }

    .workbench-info h1 {
      margin: 0 0 6px 0;
      font-size: 32px;
      font-weight: 800;
      color: var(--text-main);
      letter-spacing: -0.5px;
    }

    .workbench-subtitle {
      margin: 0;
      font-size: 15px;
      color: var(--text-muted);
      font-weight: 500;
    }

    .workbench-date-badge {
      display: flex;
      align-items: center;
      gap: 12px;
      background: var(--bg-main);
      border: 1px solid var(--border);
      padding: 14px 20px;
      border-radius: 16px;
    }
    .workbench-date-badge .material-icons {
      font-size: 28px;
      color: var(--primary);
    }
    .workbench-date-badge div {
      display: flex;
      flex-direction: column;
    }
    .date-day {
      font-size: 12px;
      font-weight: 600;
      color: var(--text-muted);
      text-transform: uppercase;
      letter-spacing: 0.5px;
    }
    .date-num {
      font-size: 15px;
      font-weight: 800;
      color: var(--text-main);
    }

    /* Metrics Ribbon */
    .metrics-ribbon {
      display: grid;
      grid-template-columns: repeat(4, 1fr);
      gap: 16px;
      margin-bottom: 28px;
    }
    .metric-pill {
      background: var(--surface);
      border: 1px solid var(--border);
      padding: 16px 20px;
      border-radius: 16px;
      display: flex;
      align-items: center;
      gap: 14px;
      box-shadow: var(--shadow);
    }
    .metric-dot {
      width: 12px;
      height: 12px;
      border-radius: 50%;
      flex-shrink: 0;
    }
    .metric-dot.terracotta { background: var(--primary); box-shadow: 0 0 10px rgba(200, 90, 50, 0.4); }
    .metric-dot.amber { background: var(--accent); box-shadow: 0 0 10px rgba(217, 119, 6, 0.4); }
    .metric-dot.teal { background: var(--success); box-shadow: 0 0 10px rgba(13, 148, 136, 0.4); }
    .metric-dot.gold { background: #f59e0b; box-shadow: 0 0 10px rgba(245, 158, 11, 0.4); }

    .metric-data {
      display: flex;
      flex-direction: column;
    }
    .metric-data strong {
      font-size: 18px;
      font-weight: 800;
      color: var(--text-main);
    }
    .metric-data span {
      font-size: 12px;
      color: var(--text-muted);
      font-weight: 600;
    }

    /* Action Tiles Grid */
    .actions-workbench-grid {
      display: grid;
      grid-template-columns: repeat(2, 1fr);
      gap: 20px;
      margin-bottom: 28px;
    }

    .action-tile {
      display: flex;
      align-items: center;
      gap: 18px;
      padding: 24px;
      border-radius: 18px;
      text-decoration: none;
      border: 1px solid var(--border);
      box-shadow: var(--shadow);
      transition: all 0.25s ease;
      position: relative;
      overflow: hidden;
    }
    .tile-primary {
      background: linear-gradient(135deg, var(--primary), var(--primary-dark));
      color: white;
      border-color: transparent;
      box-shadow: 0 12px 28px rgba(200, 90, 50, 0.3);
    }
    .tile-secondary {
      background: var(--surface);
      color: var(--text-main);
    }
    .action-tile:hover {
      transform: translateY(-3px);
      box-shadow: var(--shadow-lg);
    }

    .tile-icon-circle {
      width: 48px;
      height: 48px;
      border-radius: 14px;
      background: rgba(255, 255, 255, 0.2);
      display: flex;
      align-items: center;
      justify-content: center;
      flex-shrink: 0;
    }
    .tile-primary .tile-icon-circle .material-icons { color: white; font-size: 26px; }
    .tile-secondary .tile-icon-circle { background: rgba(217, 119, 6, 0.12); color: var(--accent); }
    .tile-secondary .tile-icon-circle.amber { background: rgba(217, 119, 6, 0.12); color: var(--accent); }

    .tile-content { flex: 1; }
    .tile-content h3 { margin: 0 0 4px 0; font-size: 17px; font-weight: 800; }
    .tile-content p { margin: 0; font-size: 13px; opacity: 0.85; line-height: 1.4; }
    .tile-arrow { font-size: 24px; opacity: 0.8; transition: transform 0.2s; }
    .action-tile:hover .tile-arrow { transform: translateX(6px); opacity: 1; }

    /* Modules Grid */
    .modules-grid {
      display: grid;
      grid-template-columns: repeat(4, 1fr);
      gap: 20px;
      margin-bottom: 28px;
    }

    .module-card {
      background: var(--surface);
      border: 1px solid var(--border);
      border-radius: 18px;
      padding: 24px;
      text-decoration: none;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      min-height: 220px;
      box-shadow: var(--shadow);
      transition: all 0.25s ease;
      position: relative;
      overflow: hidden;
    }
    .module-card:hover {
      transform: translateY(-4px);
      box-shadow: var(--shadow-lg);
      border-color: var(--primary);
    }
    .module-top {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 18px;
    }
    .module-icon {
      width: 48px;
      height: 48px;
      border-radius: 12px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .card-terracotta .module-icon { background: rgba(200, 90, 50, 0.12); color: #c85a32; }
    .card-amber .module-icon { background: rgba(217, 119, 6, 0.12); color: #d97706; }
    .card-teal .module-icon { background: rgba(13, 148, 136, 0.12); color: #0d9488; }
    .card-blue .module-icon { background: rgba(37, 99, 235, 0.12); color: #2563eb; }

    .module-badge {
      background: var(--bg-main);
      color: var(--text-muted);
      border: 1px solid var(--border);
      padding: 4px 10px;
      border-radius: 12px;
      font-size: 11px;
      font-weight: 700;
      text-transform: uppercase;
      letter-spacing: 0.5px;
    }

    .module-body h2 {
      margin: 0 0 8px 0;
      font-size: 18px;
      font-weight: 800;
      color: var(--text-main);
    }
    .module-body p {
      margin: 0;
      font-size: 13px;
      color: var(--text-muted);
      line-height: 1.5;
    }

    .module-footer {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-top: 20px;
      padding-top: 14px;
      border-top: 1px solid var(--border);
      font-size: 13px;
      font-weight: 700;
      color: var(--primary);
    }
    .module-footer .material-icons { font-size: 18px; transition: transform 0.2s; }
    .module-card:hover .module-footer .material-icons { transform: translateX(4px); }

    /* Artisan Tip Card */
    .artisan-tip-card {
      display: flex;
      align-items: center;
      gap: 16px;
      padding: 20px 24px;
      background: var(--surface);
      border-radius: 16px;
      border: 1px solid var(--border);
    }
    .tip-icon { font-size: 28px; }
    .tip-text { font-size: 14px; color: var(--text-muted); line-height: 1.5; }
    .tip-text strong { color: var(--text-main); }
    .tip-text a { color: var(--primary); font-weight: 700; text-decoration: none; }
    .tip-text a:hover { text-decoration: underline; }

    @media (max-width: 768px) {
      .desktop-only { display: none !important; }
      .mobile-only { display: block !important; }
    }
  `]
})
export class DashboardComponent implements OnInit {
  stats: DashboardStats | null = null;
  todayDate = new Date();

  constructor(private apiService: ApiService) {}

  ngOnInit() {
    this.apiService.getDashboardStats().subscribe({
      next: (data) => this.stats = data,
      error: (err) => console.error('Errore caricamento statistiche', err)
    });
  }
}
